<script setup lang="ts">
import SatelliteEmailListField from '@satellite/components/elements/forms/EmailListField.vue';
import HelpTooltip from '@/components/elements/basic/HelpTooltip.vue';

const { testId = undefined } = defineProps<{ testId?: string }>();
</script>

<!-- Satellite's EmailListField with Miranda's tooltip, which also shows inside Miranda dialogs. -->
<template>
  <satellite-email-list-field :test-id="testId">
    <template #tooltip="{ text }">
      <help-tooltip :text="text" />
    </template>
  </satellite-email-list-field>
</template>
